export const SELF_ONBOARDING_PATHS = {
  COMPATIBILITY: "/selfonboarding/compatibility/check/",
  ACCESS: "/selfonboarding/compatibility/access",
  ACCESS_SUCCESS: "/selfonboarding/compatibility/access-success",
  ACCESS_FAILED: "/selfonboarding/compatibility/access-failed",
  AUTHENTICATION_CALLBACK:
    "/selfonboarding/compatibility/authentication-callback",
};

export const SELF_ONBOARDING_ROUTES = [SELF_ONBOARDING_PATHS.COMPATIBILITY];

export const SELF_ONBOARDING_ACCESS_ROUTES = [
  SELF_ONBOARDING_PATHS.ACCESS,
  SELF_ONBOARDING_PATHS.ACCESS_FAILED,
  SELF_ONBOARDING_PATHS.ACCESS_SUCCESS,
  SELF_ONBOARDING_PATHS.AUTHENTICATION_CALLBACK,
];
